import { c as _c } from "react/compiler-runtime";
import { SvgIcon } from '@mui/material';
const Payments = t0 => {
  const $ = _c(5);
  const {
    sx
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M3.5 15V17H18.5V5H16.5V6.46295H17.037V15.537H4.96295V15H3.5Z" fill="black" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M15.037 4.46295H2.96295V13.537H15.037V4.46295ZM1.5 3V15H16.5V3H1.5Z" fill="black" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M9.5 7.46295H8.5C8.2034 7.46295 7.96295 7.7034 7.96295 8V10C7.96295 10.2966 8.2034 10.537 8.5 10.537H9.5C9.7966 10.537 10.037 10.2966 10.037 10V8C10.037 7.7034 9.7966 7.46295 9.5 7.46295ZM8.5 6C7.39543 6 6.5 6.89543 6.5 8V10C6.5 11.1046 7.39543 12 8.5 12H9.5C10.6046 12 11.5 11.1046 11.5 10V8C11.5 6.89543 10.6046 6 9.5 6H8.5Z" fill="black" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== sx) {
    t4 = <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" sx={sx}>{t1}{t2}{t3}</SvgIcon>;
    $[3] = sx;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Payments;